module.exports = __webpack_public_path__ + "img/contact.732d762f.png";